"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementWiseDifference = void 0;
exports.sumAbsoluteDifference = sumAbsoluteDifference;
exports.sumSquaredDifference = sumSquaredDifference;
exports.euclideanDistance = euclideanDistance;
exports.maxDifference = maxDifference;
const ramda_1 = require("ramda");
const arraySum_1 = require("./arraySum");
const elementWiseDifference = (array1, array2) => array1.map((_, i) => array1[i] - array2[i]);
exports.elementWiseDifference = elementWiseDifference;
/**
 * https://numerics.mathdotnet.com/Distance.html#Sum-of-Absolute-Difference-SAD
 * @param array1
 * @param array2
 * @returns
 */
function sumAbsoluteDifference(array1, array2) {
    return (0, ramda_1.pipe)(exports.elementWiseDifference, (0, ramda_1.map)(Math.abs), arraySum_1.arraySum)(array1, array2);
    //   return array1.reduce((total, _, idx) => total + Math.abs(array1[idx] - array2[idx]), 0)
}
/**
 * https://numerics.mathdotnet.com/Distance.html#Sum-of-Squared-Difference-SSD
 * @param array1
 * @param array2
 * @returns
 */
function sumSquaredDifference(array1, array2) {
    return (0, ramda_1.pipe)(exports.elementWiseDifference, (0, ramda_1.map)(squared), arraySum_1.arraySum)(array1, array2);
}
const squared = (num) => num ** 2;
/**
 * https://numerics.mathdotnet.com/Distance.html#Euclidean-Distance
 * @param array1
 * @param array2
 * @returns
 */
function euclideanDistance(array1, array2) {
    return (0, ramda_1.pipe)(sumSquaredDifference, Math.sqrt)(array1, array2);
}
/**
 * This is useful for normalising the difference results, but will not work if using a function that doesn't subtract pairwise attributes
 * @param length
 * @param maxAttributeDifference
 * @param diffFn
 * @returns the maximum difference a given function can yield given a fixed array length and maximum attribute difference
 */
function maxDifference(length, maxAttributeDifference, diffFn) {
    const zeroArray = Array(length).fill(0);
    const maxDifferenceArray = Array(length).fill(maxAttributeDifference);
    return diffFn(zeroArray, maxDifferenceArray);
}
